import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';

@Injectable()
export class IrisBasePathInterceptor implements HttpInterceptor {
  private readonly envService = inject(IrisEnvironmentService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.includes('/ui/ui2') && !req.url.includes('http://') && !req.url.includes('https://')) {
      return next.handle(req.clone({
        url: this.envService.get<string>('apiUrl') + req.url,
      }));
    }
    return next.handle(req);
  }
}
